export default __webpack_public_path__ + "static/media/office2.2cce81e2.jpg";